import {Analysis} from 'types/model/analyses/Analysis';
import {SelectOptions} from 'forms/components/BasicSelect';

export const getAnalysesOptions = (analyses: Analysis[]): SelectOptions<string> =>
    analyses.map(analysis => ({value: analysis.id.toString(), label: analysis.abbr}));
